import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  careLineData: null,
  graceScore: null,
  careLinesActive: null,
  errorData: null,
  error: null,
  loading: null,
};

export function careLines(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      /**
       * ---------------------------------------------------
       *  LINHAS DE CUIDADO ATIVAS NA INSTITUIÇÃO
       * ---------------------------------------------------
       */

      case types.LISTAR_LCS_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LISTAR_LCS_SUCCESS: {
        draft.careLinesActive = action.payload.careLinesActive;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LISTAR_LCS_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       *  CANCER DE MAMA
       * ---------------------------------------------------
       */

      case types.LC_CANCER_MAMA_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_CANCER_MAMA_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LC_CANCER_MAMA_FAILURE: {
        console.log('LC_CANCER_MAMA_FAILURE', action);

        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // UPDATE CANCER DE MAMA

      case types.LC_CANCER_MAMA_UPDATE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_CANCER_MAMA_UPDATE_SUCCESS: {
        draft.loading = false;
        draft.careLineData = action?.payload?.careLineData;
        draft.error = false;
        break;
      }
      case types.LC_CANCER_MAMA_UPDATE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GET CANCER DE MAMA

      case types.GET_CANCER_MAMA_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_CANCER_MAMA_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_CANCER_MAMA_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }
      /**
       * ---------------------------------------------------
       *  QUADRIL
       * ---------------------------------------------------
       */

      case types.LC_QUADRIL_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_QUADRIL_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LC_QUADRIL_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // UPDATE QUADRIL

      case types.LC_QUADRIL_UPDATE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_QUADRIL_UPDATE_SUCCESS: {
        draft.loading = false;
        draft.careLineData = action?.payload?.careLineData;
        draft.error = false;
        break;
      }
      case types.LC_QUADRIL_UPDATE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GET QUADRIL

      case types.GET_QUADRIL_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_QUADRIL_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_QUADRIL_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }
      /**
       * ---------------------------------------------------
       *  ACIDENTE VASCULAR CEREBRAL (AVC)
       * ---------------------------------------------------
       */

      case types.LC_AVC_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_AVC_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LC_AVC_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // UPDATE AVC

      case types.LC_AVC_UPDATE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_AVC_UPDATE_SUCCESS: {
        draft.loading = false;
        draft.careLineData = action?.payload?.careLineData;
        draft.error = false;
        break;
      }
      case types.LC_AVC_UPDATE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GET AVC

      case types.GET_AVC_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_AVC_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_AVC_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      /**
       * ---------------------------------------------------
       *  SCA
       * ---------------------------------------------------
       */

      case types.LC_SCA_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_SCA_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LC_SCA_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // UPDATE SCA

      case types.LC_SCA_UPDATE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_SCA_UPDATE_SUCCESS: {
        draft.loading = false;
        draft.careLineData = action?.payload?.careLineData;
        draft.error = false;
        break;
      }
      case types.LC_SCA_UPDATE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GET SCA

      case types.GET_SCA_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_SCA_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_SCA_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GRACE

      // case types.GRACE_SUCCESS: {
      //   draft.graceScore = action?.payload?.graceScore;
      //   draft.loading = false;
      //   draft.error = false;
      //   break;
      // }
      // case types.GRACE_FAILURE: {
      //   draft.graceScore = null;
      //   draft.loading = false;
      //   draft.error = true;
      //   break;
      // }

      /**
       * ---------------------------------------------------
       *  CANCER DE PROSTATA
       * ---------------------------------------------------
       */

      case types.LC_CANCER_PROSTATA_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_CANCER_PROSTATA_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LC_CANCER_PROSTATA_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // UPDATE CANCER DE PROSTATA

      case types.LC_CANCER_PROSTATA_UPDATE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_CANCER_PROSTATA_UPDATE_SUCCESS: {
        draft.loading = false;
        draft.careLineData = action?.payload?.careLineData;
        draft.error = false;
        break;
      }
      case types.LC_CANCER_PROSTATA_UPDATE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GET CANCER DE PROSTATA

      case types.GET_CANCER_PROSTATA_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_CANCER_PROSTATA_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_CANCER_PROSTATA_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }
      /**
       * ---------------------------------------------------
       *  SEPSE
       * ---------------------------------------------------
       */

      case types.LC_SEPSE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_SEPSE_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.LC_SEPSE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // UPDATE SEPSE

      case types.LC_SEPSE_UPDATE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.LC_SEPSE_UPDATE_SUCCESS: {
        draft.loading = false;
        draft.careLineData = action?.payload?.careLineData;
        draft.error = false;
        break;
      }
      case types.LC_SEPSE_UPDATE_FAILURE: {
        draft.errorData = action?.payload?.errorData;
        draft.loading = false;
        draft.error = true;
        break;
      }

      // GET SEPSE

      case types.GET_SEPSE_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.GET_SEPSE_SUCCESS: {
        draft.careLineData = action?.payload?.careLineData;
        draft.loading = false;
        draft.error = false;
        break;
      }
      case types.GET_SEPSE_FAILURE: {
        draft.loading = false;
        draft.error = true;
        break;
      }

      default:
        return state;
    }
  });
}
